import { Routes } from '@angular/router';
import { NuevoComponent } from './components/nuevo/nuevo.component';
import { RecibidoComponent } from './components/recibido/recibido.component';
import { EnviadoComponent } from './components/enviado/enviado.component';
import { BorradorComponent } from './components/borrador/borrador.component';
import { BusquedaComponent } from './components/busqueda/busqueda.component';
import { ReportesComponent } from './components/reportes/reportes.component';
import { LoginComponent } from './commons/login/login.component';
import { InitComponent } from './commons/init/init.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { SeguimientoComponent } from './components/seguimiento/seguimiento.component';
import { CarpataComponent } from './components/carpata/carpata.component';
import { ListaEnvioComponent } from './components/administracion/lista-envio/lista-envio.component';
import { authGuard } from './guards/auth.guard';
import { authenticatedGuard } from './guards/authenticated.guard';
import { AdministracionComponent } from './components/administracion/administracion.component';
import { DatosPersonalesComponent } from './components/administracion/datos-personales/datos-personales.component';
import { CambioContrasenaComponent } from './components/administracion/cambio-contrasena/cambio-contrasena.component';
import { FirmaElectronicaComponent } from './components/administracion/firma-electronica/firma-electronica.component';
import { ResumenComponent } from './components/resumen/resumen.component';
import { DlgSignatureComponent } from './commons/dlg-signature/dlg-signature.component';
import { NuevaTareaComponent } from './components/tarea/nueva/tarea-nueva.component';
import { ResponderComponent } from './components/recibidos-acciones/responder/responder.component';
import { ReasignarComponent } from './commons/reasignar/reasignar.component';
import { ComentarComponent } from './components/comentar/comentar.component';
import { ArchivarComponent } from './commons/archivar/archivar.component';
import { sgdAdminGuard } from './guards/sgd-admin.guard';
import { ParametrosConfiguracionComponent } from './components/administracion/admin/parametros-configuracion/parametros-configuracion.component';
import { TiposDocumentosComponent } from './components/administracion/admin/tipos-documentos/tipos-documentos.component';
import { PlantillasMemosComponent } from './components/administracion/admin/plantillas-memos/plantillas-memos.component';
import { TramiteAbreviacionesComponent } from './components/administracion/admin/tramite-abreviaciones/tramite-abreviaciones.component';
import { BandejaReasignadosComponent } from './components/bandeja-reasignados/bandeja-reasignados.component';
import { TareaRecibidaEnviadaComponent } from './components/tarea/recibida-enviada/tarea-recibida-enviada.component';
import { BandejaArchivadosComponent } from './components/bandeja-archivados/bandeja-archivados.component';
import { RestaurarComponent } from './commons/restaurar/restaurar.component';
import { ReasignarRevertirComponent } from './commons/reasignar-revertir/reasignar-revertir.component';
import { DireccionarComponent } from './components/direccionar/direccionar.component';
import { RedactarComponent } from './commons/redactar/redactar.component';
import { BandejaAdmReasignarComponent } from './components/administracion/admin/bandeja-adm-reasignar/bandeja-adm-reasignar.component';
import { InteractiveOrgChartComponent } from './components/interactive-org-chart/interactive-org-chart.component';
import { ReasignacionMasivaComponent } from './components/administracion/admin/reasignacion-masiva/reasignacion-masiva.component';
import { BuzonComponent } from './components/administracion/buzon/buzon.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent, canActivate: [authenticatedGuard] },
  {
    path: '',
    component: InitComponent,
    children: [
      { path: '', component: DashboardComponent },
      { path: 'nuevo', component: NuevoComponent },
      { path: 'editar/:documentID', component: NuevoComponent },
      { path: 'resumen/:id', component: ResumenComponent, data: { bandejaIndex: 'map' } },
      { path: 'redactar/:id', component: RedactarComponent, data: { bandejaIndex: 'map' } },
      { path: 'editar/redactar/:id', component: RedactarComponent, data: { bandejaIndex: 'map' } },
      { path: 'finalizar/:id', component: ResumenComponent },
      { path: 'borrador', component: BorradorComponent },
      { path: 'recibido', component: RecibidoComponent },
      { path: 'enviado', component: EnviadoComponent },
      { path: 'reasignados', component: BandejaReasignadosComponent },
      { path: 'archivados', component: BandejaArchivadosComponent },
      { path: 'visualizador', component: DlgSignatureComponent },
      { path: 'finalizar/:idDoc/:idAnx', component: DlgSignatureComponent },
      { path: 'firmarAnexo/:idDoc/:idAnx/:previousRoute', component: DlgSignatureComponent },
      { path: 'busqueda', component: BusquedaComponent },
      { path: 'reportes', component: ReportesComponent },
      { path: 'comentar', component: ComentarComponent },
      { path: 'enviada', component: TareaRecibidaEnviadaComponent },
      { path: 'recibida', component: TareaRecibidaEnviadaComponent },
      { path: 'recibidos/responder/:documentID', component: ResponderComponent },
      { path: 'alcance/:documentID', component: ResponderComponent },
      { path: 'seguimiento', component: SeguimientoComponent },
      { path: 'carpeta', component: CarpataComponent },
      
      { path: 'administracion', component: AdministracionComponent, 
        children: [
          { path: '', component: DatosPersonalesComponent },
          { path: 'lista-envio', component: ListaEnvioComponent },
          { path: 'datos-personales', component: DatosPersonalesComponent },
          { path: 'cambio-contrasena', component: CambioContrasenaComponent },
          { path: 'firma-electronica', component: FirmaElectronicaComponent },
          { path: 'buzon', component: BuzonComponent },
          {
            path: "",
            children: [
              { path: "parametros-configuracion", component: ParametrosConfiguracionComponent,},
              { path: "tipos-documentos", component: TiposDocumentosComponent },
              { path: "plantillas-memos", component: PlantillasMemosComponent },
              { path: "tramite-abreviaciones", component: TramiteAbreviacionesComponent },
              { path: "reasignacion", component: BandejaAdmReasignarComponent },
              { path: "reasignacion-masiva", component: ReasignacionMasivaComponent },
            ],
            canActivate: [sgdAdminGuard]
          }
        ],
      },
      
      
      // { path: 'administracion/respaldo-documentos', component: RespaldoDocumentosComponent },
      { path: 'tarea', component: NuevaTareaComponent, data: { documentIDs: 'map' } },
      { path: 'documento/reasignar', component: ReasignarComponent, data: { documentIDs: 'map' } },
      { path: 'documento/direccionar', component: DireccionarComponent, data: { documentIDs: 'map' } },
      { path: 'documento/archivar', component: ArchivarComponent, data: { documentIDs: 'map' } },
      { path: 'documento/restaurar', component: RestaurarComponent, data: { documentIDs: 'map' } },
      { path: 'documento/recuperar', component: ReasignarRevertirComponent, data: { documentIDs: 'map' } },
      { path: 'interactive-org-chart', component: InteractiveOrgChartComponent },
    ],
    canActivate: [authGuard],
  }
];
